export default {
  creator: 'Creator',
  pleaseEnterADescription: 'Enter description',
  englishFields: 'English Fields',
  name: 'Name',
  sourceId: 'Source ID',
  sourceAttribute: 'Source Attribute',
  numberOfUnSolvedAIFeedback: 'AI Unsolved Feedback Count',
  pleaseEnterRequiredField: 'Please enter required field',
  feedbackSource: 'Feedback Source:',
  importClassification: 'Import Classification',
  exportClassification: 'Export All Classifications',
  takeEffect: 'Take effect',
  updateToTerminal: 'Update to Terminal',
  inTheManagementView: 'After operating on classifications, remember to click',
  updateToTerminal2: 'Update to Terminal',
  confirmUpdateTo: 'Update to Terminal?',
  createANewFirstLevelScore: 'Create First-Level Classification',
  copyData: 'Copy Data',
  newSource: 'New Source',
  sourceManagement: 'Source Management',
  userView: 'User View',
  managementView: 'Management View',
  exportFailed: 'Export failed:',
  exportSuccessful: 'Export successful',
  deleteCategory: 'Delete Category',
  doYouWantToDeleteThis: 'Delete this category?',
  optionalCustomization: 'Optional Custom Fields',
  feedbackFillingPage:
    'Required custom fields shown after users select this category',
  feedbackRequiredField: 'Required Fields',
  statusIsReturned: 'Status is "Replied"',
  doNotMakeAnyChanges: 'Do not make any changes',
  automaticReplyLetter: 'Auto Reply Status Change',
  whenConfiguringSelf:
    'Users receive auto-reply text for this category after submitting feedback.',
  automaticReply: 'Auto Reply',
  pleaseSelectFeedback: 'Please select feedback source',
  pleaseInputProcessing: 'Enter processor, separate multiple with ;',
  inTermsOfFeedbackTypes: 'Visible in feedback types',
  invisible: 'Invisible',
  so: 'Visible',
  visibleToUsers: 'Visible to Users',
  pleaseEnterThePrompt: 'Enter prompt (max 250 characters)',
  customLink: 'Custom Link',
  pleaseEnterCustomLink: 'Please enter the custom link',
  invalidCustomLink:
    'Invalid link format. It should start with http://, https://, or a valid scheme/path',
  classificationId: 'Classification ID',
  suggestionsForUsers:
    'Recommended: configure in lowest visible category; prompt appears in input box.',
  classificationTips: 'Classification Tips',
  tips: 'Tip:',
  suggestionsForUsers2:
    'Recommended: configure in highest visible category; description appears under category name.',
  classificationDescription: 'Description',
  describe: 'Description:',
  classificationAttribute: 'Classification Attribute',
  pleaseEnterCorrectly: 'Enter correct processor, separate multiple with ;',
  groupLocation: 'Group Location',
  number: 'Number',
  thereIsCurrentlyNoAssociatedF: 'No FAQ associated, click to associate',
  clickToAdd: 'Click to Add',
  usedAfterConfiguration:
    'FAQs display on feedback page when users select this category',
  guessWhatYouWantToAsk: 'Guess what you want to ask',
  lenovoFaq: 'Lenovo FAQ',
  confirmToDelete: 'Delete this association?',
  searchFaq: 'Search FAQ',
  youHaveAdded: 'Added',
  addQuestionsTo: 'Add questions to category:',
  addFaq: 'Add FAQ',
  maximumNumberOfAssociations: 'Max 5 FAQs allowed, please adjust and retry',
  adjustSortingTo: 'Sorting adjusted, click update to Terminal',
  atDifferentLevels: 'Cannot drag between different levels',
  iteml: '{val1} Subcategory',
  pleaseFillInOnTheRightSide: 'Fill in category details on the right',
  pleaseSelectWhatYouNeed: 'Select feedback source to import into',
  uploadCategoryE: 'Upload Category Excel',
  importFailedToSave: 'Import failed, errors:',
  theIThCategory: 'Line {val1}: no parent category',
  theIThLineExists:
    'Line {val1}: contains "Unclassified", category name cannot include "Unclassified"',
  unclassified: 'Unclassified',
  uploadFailedE: 'Upload failed: {val1}',
  faile: '{val1} import failed, errors:',
  count: '{val1} imported successfully',
  theUserViewIs:
    'User view is a preview of directory tree, detailed view not available',
  thereAreCurrentlyNoClassificationLettersAvailable:
    'No classification info, click classification tree to see details',
  classificationManagement: 'Classification Management',
  helpAndFeedback: 'Help and Feedback Optional Classification',
  deleteSourceMissing: 'Delete source failed',
  deleteSource: 'Source deleted',
  deleteCategoryLost: 'Delete category failed',
  deleteClassificationAs: 'Classification deleted',
  updateToTerminal3: 'Update to Terminal failed',
  updateToTerminal4: 'Updated to Terminal',
  firstLevelClassificationName: 'First-Level Name',
  relatedFaQs: 'Associate FAQs failed',
  relatedFaQs2: 'FAQs associated',
  newSourceLost: 'Create source failed',
  busin: '{val1} source created',
  level: '{val1} classification failed',
  level2: '{val1} classification successful, click update to Terminal',
  pleaseEnterANote: 'Enter note',
  remarks: 'Remarks',
  enableRules: 'Enable Rules',
  relationshipBetweenConditions: 'Condition Relationship',
  addTo: 'Add To',
  lengthRestrictionGrid: 'Length format: {"max":xxx, "min": xxx}',
  pleaseSelectFilter: 'Select filter conditions',
  inMultipleProjects:
    'Effective in sources with same name across multiple projects',
  applicableAfterOpening:
    'Once enabled, applies to all projects under corresponding secondary product; rules will sync',
  multiProjectApplication: 'Multi-Project',
  pleaseEnterInvalid: 'Enter invalid rule name',
  pleaseEnterTheRules: 'Enter rule name',
  ruleName: 'Rule Name',
  invalidRuleCreation: 'Invalid rule created',
  invalidRulesAreMore: 'Invalid rule updated',
  newInvalidRule: 'New Invalid Rule',
  newlyBuild: 'New Build',
  invalidRule: 'Invalid Rule',
  or: 'Or',
  and: 'And',
  totalTota: 'Total {val1} items',
  areYouSureYouWantToDelete: 'Delete this invalid rule? (Cannot be restored)',
  operator: 'Operator',
  updateTime: 'Update Time',
  enable: 'Enable',
  yes: 'Yes',
  invalidRuleName: 'Invalid Rule Name',
  deleteInvalidRules: 'Successfully deleted invalid rules',
  statu: '{val1} invalid rules processed successfully',
  onTheUserPage: 'Prompt text on user page',
  inputPromptText: 'Input prompt',
  fieldAnnotation: 'Field annotation',
  adminDisplayCopy: 'Radio/checkbox option hints on the feedback detail page',
  doWeNeedASchool: 'Is verification needed?',
  canBeReversedOnThePlatform: 'Can be modified in platform feedback list',
  canItBeModified: 'Is it modifiable?',
  inUserSubmission: 'Display on user feedback submission page?',
  canTheUser: 'Visible to users?',
  isItMandatory: 'Is it mandatory?',
  isSensitive: 'Sensitive word option',
  sensitiveInfo: 'In admin and data export, mask this field with an asterisk',
  pleaseEnterSorting: 'Enter sorting order',
  sortNumericalValues: 'Sorting values',
  sort: 'Sort',
  theFieldValueIsNot: 'Field value cannot be empty',
  addOptions: 'Add Options',
  pleaseEnterOptionLabel: 'Enter option display name',
  pleaseEnterOptionValue: 'Enter option value (letters/numbers)',
  fieldValueOptions: 'Field Value Options',
  maximumNumberOfCharacters: 'Max characters',
  minimumNumberOfCharacters: 'Min characters',
  cSideSection: 'User Side',
  adminSideSection: 'Admin Side',
  inputPromptPlaceholder: 'Prompt text shown in user input box',
  visible: 'Visible?',
  sortFieldTooltip:
    'Controls field display order in feedback form and admin panel',
  commonFieldTooltip: 'Common field shown when filling in feedback',
  pleaseSelectAField: 'Select field type',
  fieldType: 'Field Type',
  lettersOrNumbers:
    'Letters or numbers format for interface parameter transfer',
  fieldId: 'Field ID',
  whenReportingFeedback: 'Field name when reporting feedback',
  userEndOrFlat: 'Displayed on user or platform page (unique)',
  fieldName: 'Field Name',
  feedbackPage: 'Field content displayed in order on feedback page',
  title: '{val1} Field',
  pleaseCompleteTheForm: 'Complete the form',
  customFields: 'Custom fields modified',
  customFields2: 'Custom fields added',
  pleaseAddFields: 'Add field value options',
  currentNam: '{val1} already exists, please re-enter',
  pleaseEnterNa: 'Enter {val1}',
  defaultRemarks: 'Default Remarks',
  defaultName: 'Default Name',
  newlyAdded: 'Newly Added',
  link: 'Link',
  jsonWord: 'JSON String',
  name2: 'Name',
  check: 'Checkbox',
  singleChoice: 'Single Choice',
  floatingPointNumbers: 'Floating Point Numbers',
  integerNumber: 'Integer Numbers',
  text: 'Text',
  doYouWantToDelete: 'Delete this field?',
  deleteCustom: 'Delete Custom Field',
  pleaseEnterTheField: 'Enter field name',
  newFieldsAdded: 'New fields added',
  customFields3: 'Delete custom fields failed',
  customFields4: 'Custom fields deleted',
  sensViewPermTitle: 'Request view permission',
  sensViewPermDesc2:
    'After submitting, please notify an administrator for approval.',
  sensViewPermSucc: 'Application submitted',
  sensViewPermFail: 'Failed to submit application',
  grantPermTitle: 'Enable plain-text view (sensitive field)',
  grantPermDesc1:
    'Enable plain-text view for the sensitive custom field "{val1}" ({val2})?',
  grantPermDesc2:
    'Owners can read this field in plain text where supported. You can disable it anytime to mask values again.',
  grantPermSucc: 'Plain-text view enabled',
  grantPermFail: 'Could not enable plain-text view',
  closePlainViewTitle: 'Disable plain-text view (sensitive field)',
  closePlainViewDesc1:
    'Disable plain-text view for the sensitive custom field "{val1}" ({val2})?',
  closePlainViewDesc2:
    'Values will appear masked again where applicable. You can re-enable anytime.',
  closePlainViewSucc: 'Plain-text view disabled',
  closePlainViewFail: 'Could not disable plain-text view',
  isItMandatory2: 'Is it required?',
  fieldRemarks: 'Field Remarks',
  maximumNumberOfCharacters2: 'Max Characters',
  minimumNumberOfCharacters2: 'Min Characters',
  pendingOnline: 'Pending',
  totalTota2: 'Total {val1} items',
  confirmToDelete2: 'Confirm deletion',
  confirmCancellation: 'Confirm cancellation?',
  confirmRelease: 'Confirm release?',
  announcementLink: 'Announcement Link',
  announcementContent: 'Announcement Content',
  pleaseSelectAnnouncement: 'Select effective time',
  entryIntoForceTime: 'Effective Time',
  pleaseEnterTheAnnouncement: 'Enter announcement link',
  pleaseEnterTheAnnouncement2: 'Enter announcement content',
  editAnnouncement: 'Edit Announcement',
  newAnnouncement: 'Create Announcement',
  announcementServiceReleased: 'Announcement service error: {val1}',
  announcementDataHasBeenReleased:
    'Announcement data too long, delete unnecessary announcements first',
  noNeedForRepair: 'No announcements need modification',
  noNeedToDelete: 'No announcements need deletion',
  announcementHasExceeded:
    'Announcement limit exceeded {val1}, cannot create new',
  announcementServiceDifferences: 'Announcement service error: {val1}',
  announcementList: 'Announcement List',
  announcementServiceDifferences2: 'Announcement service error',
  graphicTutorialAttack: 'Graphic/Text/Tutorial',
  announcementBoard: 'Announcement Board',
  announcementGraphicAndText: 'Graphic Announcement',
  createANewImageAndText: 'Create New Graphic Announcement',
  imageAndTextServicesAreAvailable: 'Graphic service error: {val1}',
  theGraphicAndTextualDataHasBeenProcessed:
    'Graphic data too long, delete unnecessary graphic data first',
  noNeedForRepair2: 'No graphic modifications needed',
  noNeedToDelete2: 'No graphic deletions needed',
  theGraphicsAndTextHaveExceededTheLimit:
    'Graphics limit exceeded {val1}, cannot create new',
  differentGraphicAndTextualServices: 'Graphic service error: {val1}',
  differentGraphicAndTextualServices2: 'Graphic service error!',
  graphicAndTextualLinks: 'Graphic Links',
  imageAndTextTitle: 'Graphic Title',
  graphicCover: 'Graphic Cover',
  pleaseUploadPicturesAndText: 'Upload graphic cover',
  pleaseSelectTextAndImage: 'Select graphic sorting position',
  textAndImageSorting: 'Graphic Sorting',
  pleaseInputTextAndImages: 'Enter graphic links',
  pleaseInputTextAndImages2: 'Enter graphic title',
  uploadCover: 'Upload Cover',
  cannotExceedM: 'Cannot exceed {val1}M',
  doesNotSupportFi: 'Does not support {val1} type',
  unableToObtainIt: 'Unable to obtain uploaded image',
  editImagesAndText: 'Edit Graphic/Text',
  hotspotSorting: 'Hotspot Sorting',
  groupSorting: 'Group Sorting',
  grouping: 'Grouping',
  answer: 'Answer',
  extensionInfo: 'Extension Info',
  faqProcessingInfo: 'Processing Information',
  faqExtensionTags: 'Extension Tags',
  faqExtensionTagsCountError: 'Up to 20 extension tags are allowed',
  faqExtensionTagsItemError:
    'Each extension tag must be at most 64 characters and cannot contain semicolons',
  faqExtensionTagsBytesError:
    'Extension tags must not exceed 1024 bytes in total',
  faqProcessingStatus: 'Processing Status',
  faqStatusUnset: 'Not set',
  faqStatusReplied: 'Replied',
  faqStatusProcessing: 'Processing',
  faqStatusProcessed: 'Processed',
  faqReplyContent: 'Reply Content',
  newQuestion: 'Create',
  editQuestionS: 'Edit Question ({val1})',
  theProblemCannotBe: 'Question cannot be empty or over 200 characters',
  defaultGrouping: 'Default group',
  nextPicture: 'Next',
  ifYouOnlyWantToStop: "Use 'Disable' to stop displaying to users",
  afterDeletionThereWillBeNo: 'Deletion is permanent, proceed carefully',
  deleteFaq: 'Delete FAQ',
  strin: '{val1} Hotspot',
  showMore: 'Show More',
  hotspot: 'Hotspot',
  stopUsing: 'Deactivate',
  copyFailed: 'Copy failed',
  copySuccessful: 'Copy successful',
  addQuestions: 'Add Questions',
  quicklyAddYours: 'Quickly add your first question',
  noProblemAtTheMoment: 'No questions available',
  page: 'Page',
  the: 'The',
  articleRecord: 'Records',
  common: 'Total',
  answer2: 'Answer',
  totalTota3: 'Total {val1} Questions',
  cancelSelection: 'Cancel Selection',
  term: 'Item',
  downloadTemplate: 'Download template',
  batchImport: 'Batch Import',
  batchExport: 'Batch Export',
  uploadFailed: 'Upload Failed',
  theIThItemInTheDocument: 'Error in line {val1}, message: {val2}',
  statu2: '{val1} failed',
  statu3: '{val1} succeeded',
  thisFaqHasBeenSent:
    'FAQ already associated with group "{val1}", unassociate and try again',
  isHot: '{val1} hotspot failed',
  isHot2: '{val1} hotspot succeeded',
  tipsF: '{val1} FAQ succeeded',
  tipsF2: '{val1} FAQ failed - duplicate content',
  tipsF3: '{val1} FAQ failed - API request error',
  groupIcon: 'Group Icon',
  groupName: 'Group Name',
  newGroup: 'Create Group',
  editGroup: 'Edit Group',
  defaultGrouping2:
    "FAQs in default group won't appear to users unless set as hotspots or moved to other groups",
  deleteGroup: 'Delete Group',
  youCanAddressTheIssue: 'Set question as hotspot in content management',
  noGroupingAvailableAtTheMoment: 'No groups available',
  deleteSuccessfully: 'Deleted',
  group: '{val1} group succeeded',
  group2: '{val1} group failed',
  aHotTopicIssue: 'hot topic issues',
  share: 'Total',
  cancelHotspotLoss: 'Cancel hotspot failed',
  cancelHotspot: 'Cancel hotspot succeeded',
  adjustHotspotF: 'Adjust hotspot FAQ order failed',
  adjustHotspotF2: 'Adjust hotspot FAQ order succeeded',
  cancelHotspot2: 'Cancel hotspot',
  returnToGroup: 'Return to Group',
  aQuestion: 'question(s)',
  importProblem: 'Import Problem',
  title2: '{val1} FAQ success',
  title3: '{val1} FAQ failed, duplicate content',
  title4: '{val1} FAQ failed, API request error',
  removeTheProblem: 'Problem removed',
  removeFromGroup: 'Remove from Group',
  moreOperationNotes: 'More operation records',
  operationHistory: 'Operation History',
  hotContentManagement: 'Hot Content',
  groupManagement: 'Group Management',
  problemContentManagement: 'Problem Content',
  faqManagement: 'FAQ Management',
  enabled: 'Enabled',
  modelInf: 'Model: {val1}',
  newModel: 'Create New Model',
  copyModel: 'Copy Model',
  viewModel: 'View Model',
  changeTime: 'Change Time',
  modelDescription: 'Model Description',
  current: 'Current',
  modelName: 'Model Name',
  totalTota4: 'Total {val1} items',
  modelReplicationLost: 'Model replication failed: {val1}',
  copyTheModelInto: 'Model copied',
  modelCopyingInProgress: 'Model copying, please wait',
  doYouWantToCopyIt: 'Copy selected model?',
  exportModelLost: 'Export model failed: {val1}',
  modelDownloadLocation: 'Model download location is empty',
  exportNotAllowed: 'Export is not supported for the current model',
  modelDeletionLost: 'Model deletion failed: {val1}',
  modelDeletedAs: 'Model deleted',
  doYouWantToDeleteIt: 'Delete selected model?',
  startTheModel: 'Start model failed: {val1}',
  enableThisModel: 'Enable model failed',
  successfullyEnabledThis: 'Model enabled',
  areYouSureToStart: 'Enable selected model?',
  modificationFailedPlease: 'Modification failed: Please confirm and retry',
  theParentNodeCannot:
    'Parent node cannot be moved to child node, category reset',
  sameNameExists: 'Category with same name exists, category reset',
  addIte: 'Add {val1} subcategory',
  addAFirstLevelScore: 'Add First-Level Category',
  addSel: 'Add {val1} subcategory',
  pleaseReferToTheTableBelow:
    'Fill in form below and save to complete category addition',
  pleaseUploadTheFile: 'Upload file to generate model',
  displayDisabled: 'Display Disabled',
  draggingSucceeded: 'Priority updated',
  hideDisabledPoints: 'Hide disabled categories',
  displayDisabledPoints: 'Display disabled categories',
  aisee: 'Aisee Assistant',
  needToActivateSelf: 'Need to enable auto-reply, please contact',
  whenConfiguringSelf2:
    'Users receive auto-reply text for this category after smart classification matches',
  automaticReplyConfiguration: 'Auto Reply Configuration',
  existsUnderTheCategory: 'Subcategories exist, continue deleting?',
  areYouSureToDelete: 'Are you sure you want to delete?',
  historicalData: 'Historical Data:',
  priority: 'Priority:',
  senior: 'Senior',
  batchAdd: 'Batch Add',
  addBlockingWords: 'Add Blocking Words',
  thereAreCurrentlyNoBlockedWordsAvailable: 'No blocking words available',
  blockWords: 'Blocking Words:',
  ifSelectedAfterConfiguration:
    'If selected custom fields have values after configuration, it will hit the smart classification',
  customFields5: 'Custom Fields:',
  addErrorCode: 'Add Error Code',
  errorCode: 'Error Code',
  thereAreCurrentlyNoErrorCodesAvailable: 'No error codes available',
  errorCode2: 'Error Code:',
  learnNewWords: 'Learn New Words',
  addNewWordFrequency: 'Add New Word Frequency',
  wordFrequency: 'Word Frequency',
  noWordFrequencyAvailableAtTheMoment: 'No word frequency available',
  wordFrequency2: 'Word Frequency:',
  addImageClose: 'Add Image Keywords',
  noPicturesAvailableAtTheMoment: 'No image keywords available',
  imageKeywords: 'Image Keywords:',
  addNewKeywords: 'Add New Keywords',
  noKeywordsAvailableAtTheMoment: 'No keywords available',
  keyWord: 'Keyword:',
  businessScenarios: 'Business Scenarios',
  afterConfigurationTheCommandWillBeActivated:
    'After configuration, when hitting this category, feedback type changes to selected value',
  feedbackType: 'Feedback Type:',
  pleaseFillInTheTitle: 'Please fill in the title',
  title5: 'Title:',
  basicConfiguration: 'Basic Configuration',
  batchAddM: 'Batch Add {val1}',
  successfullyUpdatedWord: 'Successfully updated word frequency',
  updateWordFrequency: 'Updating word frequency',
  categoryDeletedAs: 'Category deleted successfully',
  categoryAddedAs: 'Category added successfully',
  updateFailedPlease: 'Update failed: Please check if the title is duplicated',
  updateSuccessful: 'Update successful',
  imageKeywords2: 'Image Keywords',
  blockWords2: 'Blocking Words',
  reasoningProcess: 'Reasoning Process:',
  predictiveClassification: 'Predictive Classification:',
  pleaseEnterText: 'Please enter text',
  enterText: 'Enter Text:',
  saveModel: 'Save Model',
  uploadGeneratedModel: 'Upload Generated Model',
  unsupervisedDownload: 'Download Unsupervised Template',
  downloadWithSupervision: 'Download Template',
  pleaseEnterTheModel: 'Please enter model description',
  thereIsCurrentlyNoModelAvailable: 'No model description available',
  modelDescription2: 'Model Description:',
  pleaseEnterTheModel2: 'Please enter model name',
  modelName2: 'Model Name:',
  model: 'Model',
  intelligentClassification: 'Intelligent Classification-',
  uploadFormatIsIncorrect: 'Upload format incorrect, please upload xls or xlsx',
  noPredictionsAvailableAtTheMoment: 'No prediction data available',
  successfulPrediction: 'Prediction successful',
  modelUpdatedTo: 'Model updated',
  modelCreation: 'Model created',
  pleaseFillInTheModel: 'Enter model name',
  usedForIntelligentClassification:
    'Intelligent Classification (use / to separate, e.g., growth/cash withdrawal)',
  pleaseEnterCo: 'Enter {val1}, separate multiple with commas or spaces',
  noResultsAvailablePlease:
    'No results available, enter feedback ID for detection',
  detectionResult: 'Detection Result',
  reset: 'Reset',
  pleaseEnterTheReverseFirst: 'Enter feedback ID first',
  feedbackId: 'Feedback ID',
  sessionId: 'Session ID',
  testing: 'Testing',
  checkFailed: 'Check failed',
  pleaseProvideFeedback: 'Enter feedback ID',
  pleaseFillTriggerCondition: 'Please fill in trigger condition',
  addPlugin: 'Add Plugin',
  noteListOnTheLeft: 'Note: Drag button on left to adjust trigger order',
  historicalTriggerRecord: 'Historical Trigger Records',
  manuallyTriggeredPress:
    'Manually triggered, sorted by enabled order on feedback detail page',
  manuallyTriggered: 'Manually Triggered',
  customFieldTrigger: 'Custom Field Triggered',
  automaticTriggerPress: 'Automatically triggered in enabled order',
  automaticTriggering: 'Automatic Triggering',
  processingPlugins: 'Processing Plugins',
  pluginManagement: 'Plugin Management',
  pluginListTab: 'Plugin List',
  pluginCenter: 'Plugin Center',
  pluginManager: 'Plugin Management',
  pleaseEnterAResponse: 'Enter response structure path',
  responseStructurePath: 'Response Structure Path',
  requestHeader: 'Request Header',
  parameter: 'Parameter',
  interfaceTimeoutInSeconds: 'Interface Timeout (seconds)',
  pleaseEnterAp: 'Enter API',
  pleaseSelectTrigger: 'Select trigger method',
  triggerMethod: 'Trigger Method',
  pluginUsage: 'Plugin Usage',
  pleaseEnterThePlugin: 'Enter plugin name',
  pluginName: 'Plugin Name',
  editPlugin: 'Edit Plugin',
  pleaseEnterVa: 'Enter value {val1}',
  pleaseEnterKe: 'Enter key {val1}',
  updatePluginMissing: 'Update plugin failed: ',
  updatePluginsTo: 'Plugin updated',
  newPluginLost: 'Create plugin failed:',
  createANewPlugin: 'Plugin created',
  pleaseEnterCorrectly2: 'Enter correct API link',
  pleaseEnterThePlugin2: 'Enter plugin name',
  field: 'Field',
  fieldName2: 'Field Name',
  triggerOrderDrag: 'Trigger order drag failed',
  triggerOrderDrag2: 'Trigger order drag succeeded',
  startupSuccessful: 'Startup successful',
  isItEnabled: 'Is it enabled?',
  purpose: 'Purpose',
  triggerType: 'Trigger Type:',
  fail: 'Fail',
  success: 'Success',
  executionStatus: 'Execution Status:',
  pluginName2: 'Plugin Name:',
  feedbackId2: 'Feedback ID:',
  coCoun: 'Total {val1} items',
  triggerPerson: 'Trigger Person',
  triggerTime: 'Trigger Time',
  returnResult: 'Return Result',
  passInParameters: 'Pass In Parameters',
  executionStatus2: 'Execution Status',
  pluginName3: 'Plugin Name',
  pleaseEnterTheLabel: 'Enter label name or keyword',
  automaticallyLabel: 'Automatically Tag',
  pleaseUseATemplate: 'Please use template for import',
  newLabel: 'Create Label',
  businessTags: 'Business Tags',
  focusOnFailure: 'Focus on Failures',
  followSuccess: 'Focus on Success',
  modificationFailed: 'Modification failed',
  theIThItemInTheDocument2: 'Error in line {val1}, tip: {val2}',
  tagListAcquisition: 'Acquire tag list failed: {val1}',
  follow: 'Follow',
  cancelFollow: 'Unfollow',
  systemLabel: 'System Label',
  priority2: 'Priority',
  tagName: 'Tag Name',
  totalTota5: 'Total {val1} items',
  pleasePrioritize: 'Set priority (value >= 0)',
  pleaseEnterCorrectly3: 'Enter correct numerical format',
  multipleKeywords: 'Multiple keywords separated by spaces',
  fuzzyMatch: 'Fuzzy match',
  pleaseEnterTheLabel2: 'Enter label name',
  pleaseEnterCorrectly4: 'Enter label name correctly',
  tagName2: 'Tag Name',
  deleteThisTag:
    'Deleting this tag prevents feedback from being searched by this tag; deletion cannot be restored',
  confirmToDeleteTheLabel: 'Delete label:',
  intTa: '{val1} label',
  deleteFailed: 'Delete failed',
  newCreationFailed: 'Creation failed',
  newCreatedSuccessfully: 'Created',
  ifYouWishTo:
    'To publish important announcements on the user feedback submission page, set references in AiSee to save development costs.',
  ifNeededForSome:
    'AiSee supports tag setting and application for feedback data.',
  basedOnTheAlreadyGenerated:
    'Link to business systems for comprehensive information through plugins.',
  ifNecessary:
    'Filter invalid feedback data by setting rules, including field values, regular expressions, etc.',
  theUserIsSubmitting:
    'When users submit feedback and select a question category, AiSee can preset corresponding classifications.',
  inUserFeedback:
    'In addition to system information, set custom fields for additional business information.',
  youCanTarget:
    'Set FAQs for common issues to auto-reply under corresponding categories, or support manual replies.',
  youCanBaseItOn:
    'Set classification based on business needs; the platform will automatically classify user feedback.',
  replyStatus: 'Manual reply status',
  clickToExpandEmptySpace: 'Click to expand empty fields',
  clickToCollapse: 'Click to collapse',
  operationHistoryRecord: 'Operation History Record',
  systemFields: 'System Fields',
  openAiDay: 'Open AI',
  clickToViewTheMost: 'Click to view best practices',
  byAnalyzingAndUsing:
    "Don't rush when encountering problems. DeepSeek is here to help! Click 'One click Analysis' to quickly locate the root cause of anomalies.",
  logAnalysis: 'Log Analysis',
  unbindTap: 'Unbind Tapd',
  copyLinkSplit: 'Copy link to share',
  screenshot: 'Screenshot (',
  feedbackInThePastYear: 'Feedback in the past year',
  to: 'to',
  feedbackContentT: 'Feedback Content: {val1}\n{val2}',
  releaseTap: 'Successfully unbound TAPD',
  opera: '{val1} failed',
  opera2: '{val1} successful',
  logInformation: 'Log Information',
  issue: 'issueId is empty',
  noChangeHistoryAvailableAtTheMoment: 'No change history available',
  remarks2: 'Remarks:',
  informationEditing: 'Info Editing',
  processingRecords: 'Processing Logs',
  city: 'City',
  country: 'Country',
  countryChina: 'China',
  countryThailand: 'Thailand',
  countryIndonesia: 'Indonesia',
  countryIndonesiaFull: 'Indonesia',
  countryMalaysia: 'Malaysia',
  countryVietnam: 'Vietnam',
  countrySingapore: 'Singapore',
  countryIndia: 'India',
  countrySouthKorea: 'South Korea',
  countryPhilippines: 'Philippines',
  countryJapan: 'Japan',
  countryBrazil: 'Brazil',
  countryMexico: 'Mexico',
  countryUnitedStates: 'United States',
  network: 'Network',
  userIp: 'User IP',
  isItRoo: 'Is it Root?',
  systemVersion: 'System Version',
  model2: 'Model',
  manufacturer: 'Manufacturer',
  equipmentAndRegion: 'Equipment and Region',
  userTags: 'User Tags',
  clickToGoToEach: 'Click to send notification to each handler via WeChat',
  clickToSend: 'Click to send notification',
  businessInformation: 'Business Information',
  sourceLink: 'Source Link',
  receivingTime: 'Receiving Time',
  chooseManualTouch:
    'Select a manually triggered plugin to execute; field update results recorded in change history',
  executePlugin: 'Execute Plugin',
  essentialInformation: 'Essential Information',
  notifyRec: 'Notification: {val1} encountered an error, please retry',
  notifyRe: 'Notified: {val1}',
  pleaseAddProcessing: 'Add handler before sending notification',
  enterCategoryName: 'Enter category name to search',
  searchFeedbackWithin: 'Search feedback content',
  itemt: '{val1} (No category)',
  content: 'Content',
  whenThePlatformReceives: 'Platform receiving time',
  pleaseChooseFi: 'Please select {val1}',
  pleaseEnterFi: 'Please enter {val1}',
  tapdFinished: 'TAPD finished',
  transferToTapd: 'Transfer to TAPD',
  oncal: 'Oncall completion',
  feedbackProcessingRecord: 'Feedback Processing Record (',
  contactInformation: 'Contact Information',
  feedbackClassification: 'Intel Classification:',
  noPermissionToRepairTemporarily:
    'No permission to modify classification temporarily',
  transferredToPar: 'Transferred to {val1}',
  feedbackProcessingStatus: 'Processing Status',
  feedbackProcessingStatusTips:
    'Processing status of conversation to problem, tapd, oncall',
  whenSubmittingFeedback: 'Feedback submission time',
  clickToViewForUse: 'View user [{val1}] feedback history for past year',
  modifyIntelligentScore: 'Intelligent classification modified',
  opera3: '{val1} failed',
  opera4: '{val1} succeeded',
  exportAllNumbers: 'Export all data',
  feedbackInput: 'Feedback Entry',
  moreOperations: 'More Operations',
  batchEditing: 'Batch Edit',
  batchReply: 'Batch Reply',
  batchAiPush: 'Batch AI Recommended Reply',
  batchExc: 'Batch Excel Import',
  singleFeedbackRecord: 'Single Feedback Entry',
  batchCancelClose: 'Batch Unfollow',
  batchFollow: 'Batch Follow',
  batchDownload: 'Batch Download',
  opera5: '{val1} failed',
  opera6: '{val1} succeeded',
  clickOnDescendingOrder: 'Click for descending order',
  cancelSorting: 'Cancel Sorting',
  clickOnAscendingOrder: 'Click for ascending order',
  pleaseSelectAttributes: 'Select attribute tags',
  attributeTags: 'Attribute Tags',
  ifThereIsNoneAfterInput: 'If no tag exists after input, press enter to add',
  pleaseSelectFeedback2: 'Select feedback type',
  pleaseSelectAUser: 'Select user classification',
  informationHasBeenEntered:
    'Entered info replaces current feedback; unentered info unchanged',
  additionFailed: 'Addition failed',
  newSuccessfullyAdded: 'Added',
  customFields6: 'Custom Field Editing',
  systemFieldCoding: 'System Field Editing',
  pleaseSelectBusiness: 'Select business scenario',
  afterSubmittingFeedback:
    'After submission, automatically push 1 WeChat notification to all handlers',
  searchForMembers: 'Search member nicknames and select',
  upToFiveUploadsAllowed: 'Up to 5 images, max 10MB',
  feedbackAttachment: 'Feedback Attachment',
  userFeedback:
    'Original link of user feedback; click to jump in feedback list after adding',
  pleaseEnterTheLink: 'Enter link',
  whenReceivingUserFeedback: 'User feedback time',
  pleaseSelectFeedback3: 'Select feedback type',
  pleaseProvideFeedback2: 'Enter feedback source',
  pleaseEnterTheUser: 'Enter user ID or account',
  theInputContentIsNot: 'Input cannot exceed 200 characters',
  pleaseEnterTheUser2: 'Enter user information (user ID or account)',
  pleaseEnterTheUser3: 'Enter user feedback content',
  pleaseEnterTheUser4: 'Enter user feedback content',
  reasonForFailure: 'Reason for failure:',
  singleMaximumLead: 'Max 2,000 entries per import',
  clickToUploadE: 'Click to upload Excel file',
  clickToDelete: 'Click to delete',
  pleaseProvideFeedback3: 'Enter feedback data',
  downloadImportModel: 'Download Import Template',
  https:
    'https://mf-dcl-1258344701.cos.ap-guangzhou.myqcloud.com/aisee%E7%AE%A1%E7%90%86%E7%AB%AF%E6%A8%A1%E7%89%88%E6%96%87%E4%BB%B6/AiSee%E5%8F%8D%E9%A6%88%E4%BF%A1%E6%81%AF%E6%89%B9%E9%87%8F%E5%AF%BC%E5%85%A5%E6%A8%A1%E6%9D%BF-v4.xlsx',
  uploadFeedbackCount: 'Upload feedback data',
  userFeedbackRecord: 'User Feedback Entry',
  usedForBatchImport: 'Batch import user feedback',
  singleMaximumLead2: 'Max 2,000 entries per import',
  feedbackOnLineI: 'Line {val1}: feedback type is empty',
  feedbackOnLineI2: 'Line {val1}: feedback user is empty',
  feedbackOnLineI3: 'Line {val1}: feedback content is empty',
  tableDataError: 'Table data error, please upload correct data',
  inputFailedE: 'Entry failed: {val1}',
  inputSuccessful: 'Entry successful',
  importFailedE: 'Import failed: {val1}',
  importSuccessful: 'Import successful',
  importResult: 'Import completed: {val1} succeeded, {val2} failed',
  importFailed: 'Import failed, please try again',
  importFailedRetryResult:
    'Import failed, please try again: {val1} succeeded, {val2} failed',
  pleaseUploadTheDocumentFirst: 'Please upload document first',
  timeSpanIsNot: 'Time span cannot exceed one year, please reselect',
  intelligentProcessing: 'Intelligent Processing',
  userInformation: 'User Information',
  pleaseSelectATime: 'Select time',
  pleaseSelectATimeOrFid: 'Select time range or feedback ID',
  search: 'Search',
  itemt2: '{val1} (No category)',
  optionalRangeOnly:
    'Optional range limited to applications under current secondary product',
  belongingToLevel3: 'Belonging to level 3 application',
  pleaseChooseFi2: 'Please select {val1}',
  pleaseEnterFi2: 'Please enter {val1}',
  transferredToPar2: 'Transferred to {val1}',
  currentProduct: 'Current Product',
  batchModificationReverse: 'Batch Modify Feedback Type',
  allApplications: 'All Applications',
  personalCenter: 'Personal Center',
  intMine: '{val1}',
  intMine2: '{val1}',
  pleaseProvideFeedback4: 'Enter feedback content',
  viewMore: 'View More',
  theLatestFourQuestions: 'Latest four questions',
  waitingForMyApprovalAuthority: 'Waiting for my approval',
  recentlyFollowed: 'Recently followed in last 7 days',
  inRecentYearsItIsExpectedToHappenAgain: 'Pending reply in last year',
  recentlyReplied: 'Replied in last 7 days',
  followUpInRecentDays: 'Issues followed up in last 30 days',
  processedInRecentDays: 'Issues processed in last 7 days',
  inputSessionMinutes: 'Search session category',
  pleaseSelectAConversation: 'Select session category',
  searchForSessionMaster: 'Search session topic',
  topicOfTheConversation: 'Session topic',
  sessionClassification: 'Session category:',
  conversationProcessingStatus: 'Session status',
  associated: 'Associated',
  // 是否转人工，目前使用关联反馈 等前端工单上线的改为反馈“关联工单”
  whetherToTransferManually: 'Whether to transfer manually',
  relatedFeedback: 'Related feedback',
  sourceOfConversation: 'Session source',
  recor: '{val1} points',
  openWidescreenMode: 'Enable widescreen mode',
  turnOffWidescreenMode: 'Disable widescreen mode',
  numberOfConversationParticipants: 'Session participants',
  numberOfSessions: 'Number of sessions',
  getFeedbackColumn: 'Failed to get feedback list:',
  enableOldModelTag: 'Use legacy model tags',
  oldModelTagSetSuccess: 'Legacy model tag setting saved',
  oldModelTagSetFailed: 'Failed to save legacy model tag setting',
  masterControl: 'Master',
  onlineConsultation: 'Online consultation',
  sessionDetails: 'Session details',
  helloThankYou:
    'Hello, thank you for waiting. Please describe your issue in detail.',
  customerService: 'CustomerService01',
  iHaveContactedYou:
    'We have connected you to a representative. Please wait. An agent will assist you soon.',
  manualService: 'Manual service',
  sorryForTheCurrentLocation:
    "Sorry, it's currently non-working hours (working days 9:00-19:00). We will reply as soon as an agent is online.",
  pleaseEnterEnterpriseWeChat:
    'Enter Enterprise WeChat account(s), separated by , or ; (e.g. zhangsan;lisi;)',
  dialogueStrategy: 'Dialogue Strategy',
  enterpriseMicroConfiguration: 'WeChat enterprise config',
  whenACEndUser:
    'Auto message to user if requesting manual service outside working hours',
  whenManuallyOffline: 'Manual offline time message',
  whenACEndUser2:
    'Auto message to user if requesting manual service during working hours',
  whenManuallyOnline: 'Manual online time message',
  weekendsAndStatutes: 'Weekends and holidays',
  humanCustomerServiceIsAvailable:
    'Manual agent online hours (non-working days)',
  defaultToWork: 'Default working days, exclude weekends and holidays',
  humanCustomerServiceIsAvailable2: 'Manual agent online hours (working days)',
  humanCustomerServiceIsAvailable3: 'Manual agent online prompt',
  whenManuallyResponding: 'Name shown in user window when manually replying',
  artificialCustomerService: 'Manual agent nickname',
  humanCustomerServiceHead: 'Manual agent avatar',
  largeModelRecognition:
    'Auto transfer to manual agent when AI detects special scenarios (e.g. emotional)',
  automaticRecognitionAfterRecognition:
    'Auto transfer to manual after recognition',
  answeringMoreThanRound:
    'If over 3 rounds, show transfer to manual button; transfer after user clicks',
  sendToManual: 'Send transfer to manual button',
  intelligentCustomerServiceTransfer:
    'Different transfer to manual modes for AI, covering various response scenarios',
  autoTransferToManualSceneSetting: 'Auto transfer to manual scene setting',
  intelligentCustomerServiceTransfer2: 'AI to manual transfer methods',
  artificialCustomerServiceBase: 'Manual agent basic settings',
  pleaseEnterAi: 'Enter prompt text when user is emotional excited',
  whenAiFails: "Auto message to user if AI can't recognize intent",
  aiIntentIsNot: 'AI intent not recognized prompt',
  correspondingCopy: 'Corresponding copy',
  userEmotionalExcited: 'User emotional excited',
  specificScene: 'Specific scene',
  specificSceneSetting: 'Transfer to manual specific scene setting',
  collectInfoCardScene: 'Collect info card scene',
  nextTimePush: 'Next push',
  duringEachConversation:
    'Max consecutive AI failures to recognize intent per session',
  withinEachConversation: 'Total AI recognition failures per session',
  aiNotRecognized: 'AI failed to recognize intent',
  fallbackTipSettings: 'Fallback tip settings',
  recognitionFailed: 'Recognition failed',
  greetings: 'Greeting',
  dclGreetings: 'Enter greeting',
  enterOnlineConsultation: 'Greeting for entering online consultation',
  pleaseEnterAi2: 'Enter AI agent nickname',
  pleaseEnterAi3: 'Enter human agent nickname',
  aiCustomerServiceIsAvailable: 'AI agent display name in user interface',
  aiCustomerService: 'AI agent nickname',
  aiCustomerServiceHead: 'AI agent avatar',
  aiRobot: 'AI bot basic settings',
  beforeEnteringTheConversation: 'Session category settings',
  roleDescription: 'Role description',
  roleDescriptionPlaceholder:
    'Describe the AI agent role positioning and reply style',
  transferToManual: 'Allow transfer to manual',
  transferToManualWay: 'Transfer to manual',
  customerServiceOperationEquipment: 'Customer service operation settings',
  aiServiceSettings: 'Customer service configuration',
  appliedToTheCEnd: 'Apply to end user',
  atTheLatestEffectiveDate: 'Last applied to end user: ',
  officiallyLaunched: 'Officially enabled',
  unsyncedConfigTip: 'Unpublished changes to end user',
  modifiedBy: 'Modified by',
  unpublishedLeaveTip:
    'There are unpublished changes to end user. Are you sure you want to leave?',
  editAndSave: 'Edit and save page settings',
  customerServiceSettings: 'Customer service settings activation notice:',
  saveFailedPlease: 'Save failed, please try again',
  onlineConfigurationHasBeenCompleted: 'Online configuration activated',
  savedSuccessfully:
    'Saved successfully! Go to the "H5 Configuration" page to preview the effect',
  firstUseAlready: 'Preset configuration injected for first time use',
  convertToManualProcessing: 'Transfer to manual handling',
  alNotRecognized: 'AI could not recognize user intent',
  preSessionSelection: 'Pre-session category selection',
  intelligentCustomerService: 'AI customer service',
  helloImGlad: 'Hello, glad to assist. How can I help you?',
  viewSwitch: 'View switch',
  pleaseEnterTheCategory: 'Enter category description',
  pleaseEnterTheCategory2: 'Enter category name',
  currentlyAvailableInMultipleLanguages:
    'No multilingual config. Please add language.',
  editMultipleLanguages: 'Edit multilingual config',
  laHasBeenSetUp: '{val1} other languages set',
  canBeGrownAtTheTop: "Select 'Next' at top to proceed",
  allUsersAreDividedInto:
    "After all user category info updates, click 'Update to Terminal' for unified effect in H5 page",
  doNotShowAgain: "Don't show again",
  allUpdatesAreNowAvailable: 'All updates now active',
  continueUpdating: 'Continue updating',
  cEndEffectiveWithdrawal: 'C-end activation prompt',
  userClassificationSettings: 'User category activation steps:',
  updateToTerminal5: 'Update to terminal effective',
  updateAllUpdates: 'Unify all updates in H5 end',
  nextStep: 'Next',
  updateAndSavePoints: 'Update and save category info',
  afterTheApplicationTakesEffect: 'Categories selectable after effective:',
  classificationHasBeenSet: 'Set categories referenced by H5 feedback:',
  cEndAssistanceAnd:
    'Feedback page category selectable on C-end; configurable by source in [Feedback Settings → User Category]',
  cannotBeOpenedAfterActivation: '(Cannot be disabled after enabling)',
  feedbackToIssue:
    'Controls if the field can be used in corresponding issue when converting feedback',
  whetherToApplyItTo: 'Apply to issue?',
  customField: 'Custom field modification failed',
  cannotBeEmpty: 'Cannot be empty',
  theSortingValueMustBe: 'Sorting value must be 0-9999',
  saveFailedPlease2: 'Save failed, check input',
  field2: '{val1} already exists, please modify',
  field3: '{val1} cannot be empty',
  refersToTheUserClicking: 'Link opened when user clicks announcement',
  confirmDeletion: 'Delete this source and its selected categories?',
  confirmDeletion2: 'Are you sure you want to delete this template?',
  filterView: 'Filter view',
  defaultView: 'Default view',
  saveCurrentTemplate: 'Save current filter conditions as a quick filter',
  saveFilter: 'Save current filter conditions as a new view',
  pleaseEnterTemplateName: 'Please enter view name',
  updateCurrentView: 'Update current view',
  templateName: 'View name',
  templateNamePlaceholder: 'Enter view name',
  canBeReferencedForUse:
    'Can be referenced for 2nd-level user category; must be set as user-visible',
  aSource: 'source(s)',
  relatedUserSegmentation: 'Linked to [User Category] (selected',
  minimumAvailableVersion: 'Minimum version',
  maximumAvailableVersion: 'Maximum version',
  pleaseSelectInvalid: 'Select expiration date',
  whenSelectingFailure: 'Select expiration date',
  neverExpire: 'Never expires',
  afterExpirationItWill: 'Will be disabled after expiration',
  theCurrentProductIs:
    'Current product uses AiSee chatbot. FAQ must be linked to category for accurate replies.',
  cEndUsersCan: 'End users visible',
  lostDuringSwitching: '(Formatting/images lost when switching)',
  plainText: 'Plain text',
  richText: 'Rich text',
  totalTota6: '{val1} items',
  setAsAHotspot: 'Set as hotspot',
  otherSettingsHaveBeenSetUp: 'Other language count set',
  whenTheValueIsNoF:
    "If 'No': FAQ only used as AI corpus; 'Yes': also shown in help H5 for user search",
  cEndUsersAre: 'End user visible',
  userClassification: 'user category(s)',
  associated2: '(associated',
  popular: 'Popular',
  multilingualSettings: 'Multilingual settings',
  copyFailed2: 'Copy failed:',
  copyCommandLost: 'Copy command failed',
  pleaseEnterTheAnswer: 'Enter answer',
  editMultipleLanguages2: 'Edit multilingual success',
  editMultipleLanguages3: 'Edit multilingual fail',
  userClicksOn:
    'After [Online Consultation] click, go directly to session (no category selection, fast answer, no ticket flow)',
  relatedFeedbackScore: 'Linked to [Feedback Category] (business category)',
  userClicksOn2:
    'After [Online Consultation] click, select category for precise AI answer and facilitate manual routing',
  relatedUserSegmentation2: 'Linked to [User Category] (user-visible category)',
  theEffectAfterSwitching: 'Comparison of effects after switching:',
  youConfirmThatF: 'Confirm linking FAQ to feedback category?',
  switchAssociated:
    'Switching linked categories will invalidate previous links',
  faqSwitching: 'FAQ switch association',
  alreadySwitchedForYou: 'Switched to [{val1}]',
  faqAssociation: 'FAQ linked to [',
  usedToIdentify: 'Identify scene and push card to collect user issues',
  informationCollectionCard: 'Info collection card config',
  groupAll: 'All groups',
  filterGroups: 'Filter groups',
  uploadFiles: 'Uploaded file is empty. Please check and retry.',
  theRowI: 'Row {val1}: Expiration date must be in the future',
  theRowI2:
    'Row {val1}: Invalid expiration date format. Use yyyy-mm-dd or yyyy-mm-dd hh:mm:ss',
  theRowI3: "Row {val1}: Invalid value for hotspot. Must be 'yes' or 'no'",
  theRowI4:
    "Row {val1}: Invalid value for end user visible. Must be 'yes' or 'no'",
  theRowI5: 'Row {val1}: Hotspot is required',
  theRowI6: 'Row {val1}: Sorting is required',
  theRowI7: 'Row {val1}: End user visible is required',
  theRowI8: 'Row {val1}: FAQ answer required',
  theRowI9: 'Row {val1}: FAQ question name required',
  stepUpdateLost: 'Step update failed, contact support',
  pleaseEnterGrouping: 'Enter group name',
  pleaseEnterTheMaximum: 'Enter max characters',
  pleaseEnterAPrompt: 'Enter prompt text',
  promptText: 'Prompt text',
  pleaseEnterOptions:
    'Enter options, separate with commas (e.g. option1,option2,option3)',
  optionValue: 'Option value',
  fieldIdOnly: 'Field ID: only letters, digits, underscore',
  pleaseEnterTheField2: 'Enter field ID',
  addField: 'Add field',
  addFieldMissing: 'Failed to add field:',
  addFieldsAs: 'Field added',
  fieldIdAlready: 'Field ID exists, use another',
  copyTitle: 'Copy title',
  newCard: 'New card',
  pleaseEnterTheCard: 'Enter card name',
  cardName: 'Card name',
  titleCopied: 'Title copied',
  currentData: 'Record, page',
  articleFaq: ' FAQ',
  pleaseEnterSearch: 'Search field name or field ID',
  onlyShowRequiredVisibleFields: 'Below are custom info fields',
  manageFields: 'Manage fields',
  relatedFaq: 'Linked FAQ',
  contentPreview: 'Preview',
  faqTitle: 'FAQ title',
  relatedFaq2: 'Link FAQ failed',
  relatedFaq3: 'Link FAQ failed:',
  relatedFaq4: 'Link FAQ succeeded',
  pleaseSelectAtLeast: 'Select at least one field',
  getFaq: 'Failed to get FAQ list',
  getFaq2: 'Failed to get FAQ list:',
  submitting: 'Submitting...',
  newInformationCollection: 'Add Card',
  editInformationCollectionCard: 'Edit card',
  scenarioDescription: 'Scenario description',
  pleaseEnterScenarioDescription: 'Enter scenario description',
  scenarioExample:
    'Tell intelligent customer service in which scenarios this card should be matched to collect information, e.g.: when the user asks about a top-up not credited to their account',
  optionPrompt: 'Option/Prompt',
  pleaseSelectTheLeftSide: 'Select a card on left or create new',
  saveSortingLost: 'Save sorting failed',
  sortSaved: 'Sorting saved',
  addFieldMissing2: 'Add field failed',
  deleted: 'Deleted',
  confirmDeletionOfThis: 'Delete this field?',
  sessionTime: 'Session time',
  updateFailed: 'Update failed',
  updateSuccessful2: 'Update succeeded',
  thereIsCurrentlyNoAssociatedF2: 'No linked FAQ',
  addAssociation: 'Add link',
  removalFailed: 'Remove failed',
  removedAssociation: 'Link removed',
  confirmToDeleteThis: 'Delete this card? Cannot be restored.',
  dateAndTime: 'Date/Time',
  decimal: 'Decimal',
  number2: 'Number',
  theCardDoesNotExist: 'Card does not exist',
  newField: 'New field',
  createCardLost: 'Create card failed',
  disableClassification: 'Disable category',
  whenHoveringTheMouse: 'Click on mouse hover',
  clearSelectedItems: 'Clear selected',
  cancelPaste: 'Undo paste',
  paste: 'Paste',
  item: 'item(s)',
  cut: 'Cut (',
  batchOperation: 'Batch:',
  updatePriority: 'Update priority failed',
  illegalOperationsExist: 'Illegal operation! {val1}',
  pasteFailed: 'Paste failed',
  pasteSuccessful: 'Pasted',
  cannotClassify: 'Cannot paste category to its subcategory',
  classifying: ' category?',
  pasteTo: 'Paste to [',
  andItsSubcategories: ' and subcategories',
  itemClassification: ' items in category',
  willTheFollowingBeIncluded: 'Include the following [',
  confirmPaste: 'Confirm paste',
  pleaseSelectFirst: 'Select a target category to paste to',
  pleaseCopyThePartsFirst: 'Copy category items first',
  thePreviousOneHasBeenRevoked: 'Last paste undone',
  noRevocable: 'No paste to undo',
  selectedHasBeenCleared: 'Selections cleared',
  cutSe: '{val1} categories cut',
  pleaseSelectFirst2: 'Select category items to copy first',
  getClassificationTree: 'Failed to get category tree',
  afterDisablingTheClassification:
    'Disabled category is hidden in feedback modification',
  afterEnablingClassification:
    'Enabled category is visible for feedback modification',
  targetingAiCustomers:
    'Parameters for manual/AI agent reply scenarios, e.g. online hours',
  customerServiceSettings2: 'Customer service settings',
  youCanAlsoTryIt: 'You may also analyze:',
  cloudRealMachineVerification: 'Verify on cloud real machine',
  similarFeedbackS: 'Similar feedback {val1}',
  similarInRecentDays: 'Similar feedback in 30 days',
  tpilo: 'tpilot scenario ID',
  expandHid: 'Expand ({val1})',
  proce: '{val1} and {val2} others',
  forma: '{val1} feedback',
  copyUserI: 'Copied user ID',
  currentCollectionItems: 'Current collection does not support reply',
  assignedHandler: 'Assigned handler',
  share2: 'Share',
  replyToHistory: 'Reply history',
  details: 'Details',
  operationFailed: 'Operation failed',
  pleaseEnterAReply: 'Enter reply content',
  moreSharing: 'More sharing',
  sameModelCalibration: 'Same device model check',
  clickToEdit: 'Click to edit',
  statusChange: 'Status change (',
  followUpOnTransferOrders: 'Transfer follow-up (',
  theCurrentStatusIsNot: 'Current status not editable',
  associatedSession: 'Linked session',
  notDeleted: 'Not deleted',
  deleteStatus: 'Delete status',
  feedbackWithinThreeDays: 'Feedback in 3 days:',
  complete: 'Completed',
  feedbackClassificationHasBeenCompleted:
    'Feedback categories updated, manual correction supported',
  feedbackAutomaticScoring:
    'After auto-classification, check here. Please refresh in 3-5 minutes.',
  feedbackIntelligentScore:
    'AI classified feedback listed here, can be manually adjusted',
  openWidescreenMode2: 'Enable widescreen mode (operation column auto hide)',
  pleaseChooseOneOr: 'Select one or more handlers',
  pleaseSelectFeedback4: 'Select feedback status',
  channel: 'Channel',
  pleaseEnterTheChannel: 'Enter channel',
  excel: 'Excel data is empty',
  feedbackTypeIncorrect:
    'Feedback type error, at row {val1} type must be: {val2}',
  timeFormatError: 'Time format error, row {val1} must be YYYY/MM/DD HH:mm:ss',
  theFeedbackContentIsNot: 'Feedback content required, row {val1}',
  whenCreatingAProblem: 'Issue creation time',
  aiSee: 'AiSee feedback list',
  aiSeeList: 'AiSee feedback list',
  loading: 'Loading...',
  queryTimeRange: 'Query time range',
  allAuditStatements: 'All approval status',
  reasonForApplication: 'Application reason',
  thirdLevelProductI: 'Level 3 product ID',
  myApplication: 'My applications',
  joinedTheApplication: 'Joined application ({val1})',
  pleaseEnterTheApplication: 'Enter app name to search',
  thirdLevelApplicationName: 'Level 3 app name',
  firstLevelProductName: 'Level 1 product name',
  myApps: 'My apps',
  theAntiThatIAmConcernedAbout: 'My followed feedback',
  waitingForAnotherReply: 'Feedback awaiting reply',
  feedbackHasBeenRepliedTo: 'Feedback replied',
  myFollowUpQuestion: 'My follow-up issues',
  operationsManagement: 'Operations management',
  noFollowUpCurrentlyAvailable: 'No issues under follow-up',
  aiConversation: 'AI sessions',
  order: 'Order',
  onlyViewMine: 'Only my subscriptions',
  allSubscribers: 'All subscription types',
  dataSource: 'Data source',
  oncallTransfer: 'Transfer to Oncall',
  allOncallTransfer: 'All',
  notificationGroupName: 'Notification group name',
  enterSubscriptionName: 'Enter subscription name',
  enterNotificationGroup: 'Enter notification group name',
  aiSee2:
    'AiSee provides feedback alerts such as push, summary, etc. for individual or group',
  youCanTakeTheNegative:
    'You can group members for certain feedback into a notification group for reuse.',
  alarmRulesOften:
    "Alert rules auto-create follow-up issues and notify when risks occur. Status auto set to 'in follow-up'.",
  notificationGroupManagement: 'Notification group management',
  subscriptionPush: 'Subscription push',
  notificationHistory: 'Notification history',
  unableToDelete: 'Irreversible after deletion, confirm?',
  generateACopy: 'Generate copy',
  timePeriod: 'Period',
  subscriptionNotificationCalendar: 'Subscription notification history',
  noFeedbackLetterAtTheMoment: 'No feedback info yet',
  copyI: '{val1}-copy',
  member: 'Member',
  total: '{val1}',
  classifyByFeedback: 'Set by feedback category',
  threeLevelClassification: 'Level 3 category',
  subcategory: 'Level 2 category',
  numbe: 'Level {val1} category',
  three: 'Three',
  two: 'Two',
  one: 'One',
  enterpriseWeChatGroupMachine: 'WeChat group bot',
  subscriber: 'Subscriber:',
  scene: 'Scene',
  unsubscribed: 'Unsubscribed',
  subscribed: 'Subscribed',
  reviseErrorE: 'Modify error: {val1}',
  activateSubscription: 'Enable subscription',
  editSubscription: 'Edit subscription',
  subscribeToTot: 'Subscribed: {val1}',
  newSubscription: 'New subscription',
  viewEnterpriseWeChat: 'View WeChat notification sample',
  detectingDataSources: 'Detecting data source',
  feedbackChannel: 'Feedback Channel',
  store: '[{val1}] - created alert rule',
  understood: 'Got it',
  clickToViewTheDisplay: 'Click to view sample',
  clickSave: 'Click to save',
  configureYourReport: 'Configure your alert rule',
  subscriptionPushNotification: 'Subscription push sample',
  enterpriseWeChatNotification: 'WeChat notification sample',
  feedbackClassificationI: 'Feedback category ({val1})',
  onlyDisplayConfiguredOnes: 'Show configured only',
  enterCategoryName2: 'Enter category/member to search',
  addMember: 'Add member',
  pleaseFillInTheRemarks: 'Enter remarks',
  notifyGroupMembers: 'Notification group members',
  feedbackClassificationOnly:
    'Feedback category only for rules with dimension [AI category]',
  youCanChoose:
    'Set notify members per feedback tag. Cannot change after creation.',
  didYouFollowTheFeedback: 'Set by feedback category?',
  pleaseEnterNotification: 'Enter notification group name',
  field4: '{val1} cannot be all spaces',
  subscribeAfterCreation:
    'After creation, subscribers will get message in WeChat',
  pleaseChooseWhatYouWant: 'Select scenes to subscribe',
  clickToViewOrder: 'View subscription sample',
  youCanDoItHere: 'Configure and save subscription rules here',
  youCanComeHere: 'Select subscription scene here',
  specificallyForSpecificScenes:
    'Transfer to manual service for specific scenarios',
  inInformationCollectionCard:
    'Information collection card set in FAQ management',
  sceneIndex: 'Scene {val1}',
  sceneName: 'Scene Name',
  pleaseEnterSceneName: 'Please enter scene name',
  sceneDescription: 'Scene Description',
  sceneDescriptionPlaceholder: 'Describe trigger conditions',
  sceneStrategy: 'Scene Strategy',
  sceneStrategyPlaceholder: 'How AI handles this scene',
  addScene: 'Add Scene',
  customIntentMissingFields:
    'Some custom scenarios are incomplete, please fill them out.',
  deleteSuccess: 'Delete successful',
  saveSuccess: 'Save successful',
  saveFailed: 'Save failed',
  chooseDefaultSuccess: 'Switch to default view successfully',
  chooseSuccess: 'Switch to {val1} view successfully',
  cEndUsersAreVisible: 'Whether end users are visible',
  createAndSyncToAllProjects: 'Create and sync to all projects',
  saveAndSyncToAllProjects: 'Save and sync to all projects',
  syncToAllProjectsTip:
    'Click to sync to all authorized projects under the first-level project',
  syncResult: 'Sync Result',
  successSyncProjects: 'Successfully synced projects',
  failSyncProjects: 'Failed to sync projects',
  reason: 'Reason',
  noSyncResult: 'No sync result',
  addConversationToFaq: 'Add conversation to FAQ',
  addNewFaq: 'Add FAQ',
  gettingRecommendedFaq: 'Getting recommended FAQ...',
  defaultAddToGroupTip:
    'Added to "Default Group" by default, invisible to end users.',
  selectFaqGroup: 'Select FAQ group',
  singleMaximumLead3: 'Max {val1} entries per import',
  selectAll: 'Select all',
  syncToOtherProjects: 'Cross-Project Sync',
  noOtherOptionalProjects: 'No other optional projects',
  pleaseSelectAtLeastOneCategory: 'Please select at least one category',
  pleaseSelectAtLeastOneProject: 'Please select at least one project',
  allProjects: 'All projects',
  syncSuccess: 'Sync successful',
  syncFailed: 'Sync failed',
  syncPartialFailed: 'Some projects failed to sync',
  triggerCondition: 'Trigger Condition',
  pleaseSelectAlarmRule: 'Please select alarm rule',
  pleaseSelectConditionField: 'Please select condition field',
  pluginExecMode: 'Execution Mode',
  apiCallback: 'API Callback',
  agentFallbackName: 'Agent {val1}',
  viewAgentTooltip: 'View Agent: {val1}',
  agentCallTag: 'Agent Call - {val1}',
  agentUnbound: 'Agent call, agent not bound',
  creatorPerson: 'Creator',
  agentModeNotSupportDetect: 'Agent mode does not support detection',
  pleaseEnterApiAddress: 'Please enter API URL',
  pleaseSelectAgent: 'Please select agent',
  pleaseConfigFilter: 'Please configure filter conditions',
  saveFailedRetry: 'Save failed, please retry',
  editTriggerSettings: 'Edit Trigger Settings',
  newTrigger: 'New Trigger',
  saveButton: 'Save',
  cancelButton: 'Cancel',
  triggerNodeTitle: 'Trigger Node',
  selectAlarmRuleLabel: 'Select Alarm Rule',
  allAlarmRules: 'All Alarm Rules',
  selectedAlarmRuleCount: '{val1} Alarm Rules Selected',
  pluginNameLabel: 'Plugin Name',
  manualTrigger: 'Manual Trigger',
  agentNotSupportManual: 'Agent mode does not support manual trigger',
  pleaseSelectSmartCategory: 'Please select smart classification',
  pleaseSelectClassification: 'Please select category',
  filterConditionTitle: 'Filter Condition',
  newFeedbackTriggerDesc: 'Triggered when new feedback is generated',
  noAvailableFields: 'No available fields',
  pleaseSelectTriggerNode: 'Please select trigger node first',
  agentLabel: 'Agent',
  execCurrentAgent: 'Execute current agent ({val1})',
  agentSelectionLabel: 'Agent Selection',
  apiAddressLabel: 'API Address',
  apiUrlPlaceholder: 'Enter API URL',
  addRequestHeader: 'Add Request Header',
  pleaseEnterKeyIndex: 'Enter Key {val1}',
  pleaseEnterValueIndex: 'Enter Value {val1}',
  newFeedbackGenerated: 'New Feedback',
  hitClassification: 'Hit Category',
  statusChangeNode: 'Status Change',
  alarmRuleNode: 'Alarm Rule',
  scheduleTriggerNode: 'Scheduled Trigger',
  triggerFrequencyLabel: 'Trigger Frequency',
  triggerWindowLabel: 'Trigger Window',
  pleaseSelectTriggerFrequency: 'Please select trigger frequency',
  unsupportedScheduleFrequency: 'Trigger frequency is not supported',
  pleaseSelectTriggerWindow: 'Please select trigger window',
  scheduleWindowMaxDays: 'Trigger window cannot exceed 3 days',
  triggerPastWindowFeedback: 'Trigger feedbacks from the past {val1} {val2}',
  scheduleConditionPrefix: 'Conditions',
  scheduleSummaryEveryPrefix: 'Every',
  scheduleSummaryRecentPrefix: 'Last',
  logicalAnd: 'AND',
  logicalOr: 'OR',
  manualTriggerNode: 'Manual Trigger',
  newFeedbackReport: 'New Feedback Report',
  customFieldBinding: 'Custom Field Binding',
  triggerAlarmText: 'Trigger Alarm',
  triggerAlarmWithName: 'Trigger Alarm {val1}',
  allClassifications: 'All Categories',
  pluginDetection: 'Plugin Detection',
  inputSectionTitle: 'Input',
  executionResultTitle: 'Execution Result',
  executeDetection: 'Execute Detection',
  emptyResultHint:
    'Fill in input parameters and click "Execute Detection", results will be shown here',
  feedbackIdPlaceholder: 'Enter feedback ID, e.g., 1a418e8bb82126aa',
  pleaseSelect: 'Please select',
  conditionIs: 'is',
  conditionBecomesTo: 'becomes',
  delayTimeSeconds: 'Delay Time (seconds)',
  delayTimeHint: 'Optional, delay before execution after trigger',
  queryFieldFailed: 'Failed to query fields',
  feedbackOptionalField: 'Optional Fields',
  feedbackOptionalFieldTip:
    'Optional custom fields shown after users select this category',
  effectiveTimeMustBeBeforeExpireTime:
    'Effective time must be before expire time',
  comingFrom: 'Scene',
  createFaqSyncKbBanner:
    'Note: The new FAQ will be automatically synced to the Knowledge Base.',
  editFaqSyncKbBanner:
    'Note: This FAQ is linked to the Knowledge Base. Changes will be synced to it.',
  faqSyncedToKb: 'Synced to Knowledge Base',
};
